export default __webpack_public_path__ + "static/media/header-color.089f5123.svg";